import { render, staticRenderFns } from "./officeOrderDetail.vue?vue&type=template&id=2f19e370&scoped=true&"
import script from "./officeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./officeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./officeOrderDetail.vue?vue&type=style&index=0&id=2f19e370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19e370",
  null
  
)

export default component.exports